<template>
  <section>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters"
      @submit.native.prevent>
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.zcncode" placeholder="医院编号"></el-input>
      </el-form-item>
      <el-form-item label="手术开始日期">
        <el-date-picker prefix-icon="" style="width: 160px" v-model="filters.startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          type="date" placeholder="开始时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="手术结束日期">
        <el-date-picker prefix-icon="" style="width: 160px" v-model="filters.endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          type="date" placeholder="结束时间"></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-select v-model="filters.province_str" @change="getRegionList" style="width: 160px" placeholder="省">
          <el-option v-for="item in area_list" :key="item.id" :label="item.regionName" :value="item.regionName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.city_str" style="width: 160px" placeholder="市">
          <el-option v-for="item in city_list" :key="item.id" :label="item.subRegionName" :value="item.subRegionName"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          " v-if="!item.IsHide" @click="callFunc(item)">
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table border :max-height="tableHeight" :data="tabel_list" header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }" highlight-current-row
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange" style="width: 100%">
          <el-table-column prop="zcnCode" label="ZCN编码"></el-table-column>
          <el-table-column prop="hocName" label="医院名称"></el-table-column>
          <el-table-column prop="post" label="填写人CD岗位号"></el-table-column>
          <el-table-column prop="name" label="填写人姓名"></el-table-column>
          <el-table-column prop="affiliatedPositionCode" label="负责人CD岗位号"></el-table-column>
          <el-table-column prop="affiliatedName" label="负责人姓名"></el-table-column>
          <el-table-column prop="regionName" label="区域"></el-table-column>
          <el-table-column prop="province" label="省份"></el-table-column>
          <el-table-column prop="city" label="城市"></el-table-column>
          <el-table-column prop="lmPost" label="直线经理岗位号"></el-table-column>
          <el-table-column prop="product_Code" label="SKU"></el-table-column>
          <el-table-column prop="number" label="数量"></el-table-column>
          <el-table-column prop="createTime" label="提交时间"></el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination :background="true" layout="prev, pager, next" @current-change="handleCurrentChange"
            :page-size="50" :total="total" style="float: right"></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import { flacs_getflacsdata, dashboard_getregionsbylevel, flacs_getflacsdataexport } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import { uploadfiles } from '@/uploadfiles'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      city_list: [],
      area_list: [],
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
        city: '',
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionName === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await dashboard_getregionsbylevel()
      this.area_list = data.data.regions
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    async ExportAccount() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await flacs_getflacsdataexport(para)
      uploadfiles(data, headers, this.loading)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      flacs_getflacsdata(para).then((res) => {
        this.total = res.data.dataCount
        this.tabel_list = res.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 230
        }
      })
    })
    this.getModules()
    this.dashboard_getregionsbylevel()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped>
/* 隐藏日期选择器的日历图标 */
::v-deep .el-date-editor .el-input__prefix {
  display: none;
}
</style>
